import styled from "@emotion/styled";
import { getGelTokens } from "@tal-gel/theming";

const Blockquote = ({ children }) => {
  return <StyledBlockQuote>{children}</StyledBlockQuote>;
};

export default Blockquote;

const StyledBlockQuote = styled.blockquote`
  font-family: ${getGelTokens().global.fontFamilySerif};
  font-size: ${getGelTokens().global.fontSizeHeadingSmall}px;
  color: ${getGelTokens().global.themeColorTextDark};
  line-height: 1.4;
  display: inline-block;
  vertical-align: top;
  padding-left: 72px;
  position: relative;
  padding-bottom: 24px;
  margin-inline-start: 0;
  margin-inline-end: 0;

  @media (max-width: 576px) {
    font-size: ${getGelTokens().global.fontSizeBodyXLarge}px;
  }

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-image: url("${process.env.PUBLIC_URL}/images/quote-icon.png");
    background-repeat: no-repeat;
    width: 43px;
    height: 34px;
    background-size: cover;
  }
`;
